import React, { useEffect, useState } from 'react'
import VideoModal from '../../HomePages/home-one/section/videoModal';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
// import WhyStudyAbroad from './WhyStudyAbroad'
// import Browse from './Browse'
// import Whatsnew2 from './whatsnew2'
// import StartTestimonials from './testimonials'
// import Aboutsection from './aboutsection'
// import IndividualUniversity from './IndividualUniversity'
import CountUp from 'react-countup'
import SearchFilterSort from './SearchFilterSort'
import Pagination from './Pagination'
import BlogGrid3 from './blogGrid3';
import Unlock from './Unlock';
import AOS from 'aos';
import 'aos/dist/aos.css';
const NewsandArticles = () => {


    const [showModal, setShowModal] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI';

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const route = all_routes;

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animate only once
        });
    }, []);

    return (
        <>
            <>

                {/* banner */}
                <section className="inner-banner">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">

                                <div className="d-flex align-items-center gap-2 gap-sm-3 gap-xl-4 flex-wrap justify-content-md-start justify-content-center">

                                </div>
                                <div className="d-sm-flex align-items-center justify-content-sm-between mt-5">
                                    <div className="d-flex text-start align-items-center justify-content-sm-start justify-content-center">
                                        <div className="avatar avatar-lg">
                                            <ImageWithBasePath
                                                className="rounded-circle"
                                                src="./assets/img/avatar/avatar10.jpg"
                                                alt="img"
                                            />
                                        </div>
                                        <div className="ms-2">
                                            <h6 className="fs-18 text-white" data-aos="fade-up">
                                                {/* <Link to='/'> */}
                                                News and articles
                                                {/* </Link> */}
                                            </h6>
                                            {/* <p className="text-white fs-14">Explore subjects
                                                With so many courses and universities to choose from, deciding where and what to study abroad can be a daunting task.
                                                Don't worry, we are here to guide you during the entire process.</p> */}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className='p-3'>

                    <SearchFilterSort />
                    <BlogGrid3 />
                    <Unlock />

                </div>


                {/* <WhyStudyAbroad />
                <Browse />
                <Whatsnew2 />
                <StartTestimonials /> */}

                {/* <Aboutsection /> */}
                {/* <IndividualUniversity /> */}

            </>

        </>
    )
}

export default NewsandArticles






